import styled from 'styled-components';

const NavContainer = styled.nav<{ reversed: boolean }>`
  background: ${p =>
    p.reversed
      ? p.theme.token('background-hero-reversed')
      : p.theme.token('background-hero-light')};
  color: #1f1f1f;
  height: ${Styles.layout.navHeight.desktop};
  margin: 0 auto;
  padding: 30px;
  width: 100%;
`;

export default NavContainer;
